<template>
  <div class="footerMain">

    <div class="footerInfo">
      <div class="footerSite">
        <!-- <img src="@/components/image/jungnanglogo.png"/> -->
        <img src="@/components/image/gangmenglogo.png"/>
        
        <div class="address">
          <el-link class="road" title="새창열림">찾아오시는 길</el-link>
          <a class="point"> · </a>
          <!-- <router-link  :to="{name: '개인정보 처리방침'}"> -->
            <el-link class="user" title="새창열림">개인정보 처리방침</el-link>
          <!-- </router-link> -->

          <!-- <li class="nonePoint">서울 중랑구 신내로 15길 197 중랑구립정보도서관(묵동) 중랑구시설관리공단</li>
          <li class="nonePoint">Copyright(c) 2022 by 중랑구 시설관리 공단. ALL Right Reserved.</li> -->
          <li class="nonePoint">경기도 광명시 사성로74 2층 Tel: 02)2610-7390</li>
          <li class="nonePoint">Copyright(c) 2023 광명도시공사 All Rights Reserved</li>
          <!-- <li id="kakao" class="nonePoint">개발사 :주식회사 디테크 대표이사 황선필 | 경기도 수원시 권선구 수성로 8, 213호 사업자 등록번호 : 183-81-01981</li> -->
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  export default ({
    data() {
      return {
        activeIndex: '1',
        activeIndex2: '1'
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  })
</script>

<style scoped>
@import '@/assets/css/reset.css';

  .footerMain{
    margin: auto;
    width: auto;
    vertical-align: bottom;
    /* padding-left: auto; */
    background-size: cover;
  }

  .footerInfo {
    width: 100vw;
    height: 14%;
    float: left;
    /* padding-left: 22%; */
    background: #F9F9F9 0% 0% no-repeat padding-box;
  }

  .footerSite{
    width: 1200px;
    margin: auto;
  }

  /* 로고 */
  img {
    margin-left: 1%;
    padding-right: 1%;
    float: left;
    /* width: 13%; */
  }

  .address {
    margin-bottom: 3%;
    margin-top: 3.5%;
  }

  .road {
    font: normal normal 300 16px/24px Noto Sans KR;
    font-weight: 300;
    letter-spacing: -0.4px;
    color: #4C4C4C;
  }

  .user {
    font: normal normal normal 16px/24px Noto Sans KR;
    font-weight: 300;
    letter-spacing: -0.4px;
    color: #358ED0 !important;
  }

  .nonePoint {
    list-style: none;
    font: normal normal 300 14px/20px Noto Sans KR;
    letter-spacing: -0.35px;
    color: #4C4C4C;
  }

  #kakao {
    margin-left: 23.5%;
  }

  /* 반응형 웹 CSS */
  @media all and (max-width: 1200px)
  { 
    .footerInfo {
      width: 100%;
      overflow: hidden;
    }
  }

  /* 반응형 웹 CSS */
  @media all and (max-width: 1024px)
  { 
    .footerInfo {
      width: 100%;
      overflow: hidden;
    }
  }

  @media all and (max-width: 768px) {

    img {
      display: none;
    }

    .footerSite {
      margin-left: 5%;
    }
    .user {
      font: normal normal 300 14px/20px Noto Sans KR;
    }
    .nonePoint {
      font: normal normal 300 14px/20px Noto Sans KR;
    }

    .road {
      font: normal normal 300 14px/24px Noto Sans KR;
    }
  }

  @media all and (max-width: 486px) {

    .footerMain {
      width: 100%;
      height: fit-content;
    }
    
    .footerInfo {
      width: 100%;
      height: 100%;
      /* padding-bottom: 5%; */
    }

    .footerSite {
      height: auto;
      width: 100vw;
      margin: 0;
    }

    /* img {
      margin-top: 1.5%;
      margin-left: 15%;
      margin-bottom: 1%;
    } */

    img {
      display: none;
    }

    .address {
      width: 90vw;
      margin-bottom: 0;
      padding-bottom: 3%;
      margin-left: 7%;
      margin-top: 2%;
    }

    .road {
      margin-left: 15%;
    }

  }

</style>